export function buildHrpDocTree(files = []) {
    const root = { folders: {}, files: [] }
    for (const file of files) {
        const parts = String(file.folder || "").split("/").filter(Boolean)
        let node = root
        for (const part of parts) {
            node.folders[part] ??= { folders: {}, files: [] }
            node = node.folders[part]
        }
        node.files.push(file)
    }
    return root
}

export function nodeAtPath(tree, folder = "") {
    let node = tree
    for (const part of String(folder).split("/").filter(Boolean)) {
        node = node?.folders?.[part]
        if (!node) return { folders: {}, files: [] }
    }
    return node
}

export function matchHrpDoc(files = [], rest = "", keyPrefix = "hrp-docs/") {
    const path = String(rest || "").replace(/^\/+|\/+$/g, "")
    if (!path) return { folder: "", file: null }
    const exact = files.find((f) => {
        const rel = f.folder ? `${f.folder}/${f.name}` : f.name
        return rel === path || f.key === path || (keyPrefix && f.key === `${keyPrefix}${path}`)
    })
    if (exact) return { folder: exact.folder, file: exact }
    return { folder: path, file: null }
}
